/**
 * TypeBreakdownCard - Displays risks by report type
 * 
 * Features:
 * - Consistent ordering via REPORT_TYPES
 * - Shows icons/emojis for each type
 * - Zero values shown (not hidden)
 * - Right-aligned tabular counts
 */
import React from 'react';

// Report types configuration
const REPORT_TYPES = [
  { id: 'HAZARD', label: 'Hazard', icon: '/icons/hazard.png', color: '#f59e0b', emoji: '⚠️' },
  { id: 'NEAR_MISS', label: 'Near Miss', icon: '/icons/warning.png', color: '#8b5cf6', emoji: '⚡' },
  { id: 'INCIDENT', label: 'Incident', icon: '/icons/danger.png', color: '#ef4444', emoji: '🔴' },
  { id: 'RISK', label: 'Risk', icon: '/icons/risk_assessment.png', color: '#3b82f6', emoji: '📊' },
  { id: 'IMPROVEMENT', label: 'Improvement', icon: null, emoji: '💡', color: '#10b981' },
  { id: 'PSYCHOSOCIAL', label: 'Psychosocial', icon: '/icons/staff_welfare.png', color: '#722F37', emoji: '🧠' },
  { id: 'WELFARE', label: 'Welfare', icon: '/icons/staff_welfare.png', color: '#ec4899', emoji: '💜' },
];

export const TypeBreakdownCard = ({ byType, onViewAll }) => {
  return (
    <div className="dashboard-card" data-testid="type-breakdown-card">
      <div className="breakdown-header">
        <h3>By Report Type</h3>
        {onViewAll && (
          <button className="view-all-link" onClick={onViewAll} data-testid="type-view-all">
            View All →
          </button>
        )}
      </div>
      <div className="type-breakdown">
        {REPORT_TYPES.map(type => {
          const count = byType?.[type.id] ?? 0;
          
          return (
            <div key={type.id} className="breakdown-row" data-testid={`type-row-${type.id}`}>
              <div className="breakdown-row-left">
                <span className="type-icon-sm">
                  {type.icon ? (
                    <img 
                      src={type.icon} 
                      alt="" 
                      style={{ width: 18, height: 18 }} 
                      onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'inline'; }}
                    />
                  ) : null}
                  <span style={{ display: type.icon ? 'none' : 'inline' }}>{type.emoji || '📄'}</span>
                </span>
                <span className="breakdown-label">{type.label}</span>
              </div>
              <span className="breakdown-count" style={{ color: count > 0 ? type.color : '#9ca3af' }}>
                {count}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TypeBreakdownCard;
